var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"h-100"},[_c('router-view'),_c('confirm-modal')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }